import React,{history,useEffect, useState, useMemo } from "react";
import Quick_links from "../utility/Quick_links";
import Hiring from "./Jobs/Hiring";
import services from "../services/services";
import { ErrorMessage } from "@hookform/error-message";
import { useForm } from "react-hook-form";
import $, { parseJSON } from 'jquery';
import { useNavigate, useParams } from "react-router-dom";
import SidebarStudent from "../utility/sidebar";
import SidebarProfile from "../utility/sidebarProfile";
const WageSurvey = () => {
    const navigate = useNavigate();
    const [profileDetails, setProfileDetails] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [countyList, setCountyList] = useState([]);
    
    //const userId=138;    

    const userId = sessionStorage.getItem("logUserId") || localStorage.getItem("logUserId");
    const companyId = sessionStorage.getItem("logCompanyId") || localStorage.getItem("logCompanyId");

    const companyIdChkLogin = sessionStorage.getItem("logCompanyId") || localStorage.getItem("logCompanyId");
    const studentIdChkLogin = sessionStorage.getItem("logStudentId") || localStorage.getItem("logStudentId");
    const jobSeekerIdChkLogin = sessionStorage.getItem("logProfileId") || localStorage.getItem("logProfileId");
    const userIdChkLogin = sessionStorage.getItem("logUserId") || localStorage.getItem("logUserId");



    const [imageName, setImageName] = useState('');
    const [imageExtension, setImageExtension] = useState('');
    const [banner, setBanner] = useState('');
    const [emaildefault, setemaildefault] = useState('');
    const [bannerBase64, setBannerBase64] = useState('');
    const [profilePicS3URL, setProfilePicS3URL] = useState('');
    //var emaildefault = '';

    const {
        register,reset,
        formState: { errors },
        handleSubmit
      } = useForm({
        criteriaMode: "all",mode: "onBlur" 
      });

$('#add_another').click(function(){  
    // var validateState = validateState();
    validateIterSurvey("add");
 
    });

    $('.btn_remove').click(function(){  
        var button_id = $(this).attr("id");   
        $('#row'+button_id+'').remove();  
     
   }); 

   

   // Dynamic wage Form Generate
  function validateIterSurvey(fromCall){
        var validateStateV = validateState();
        var validateCountyV = validateCounty();
        var validateCityV = validateCity();

        var validateTitleDV = validateTitleD();
        var validateCodeDV = validateCodeD();
         
        var i_val = $("#iterIncr").val();
        
        var jh_val = $('#junior_h'+i_val).val();
        var mh_val = $('#midlevel_h'+i_val).val();
        var manh_val = $('#manager_h'+i_val).val();
        var exh_val = $('#excutive_h'+i_val).val();
 
 
        var jy_val = $('#junior_y'+i_val).val();
        var my_val = $('#midlevel_y'+i_val).val();
        var many_val = $('#manager_y'+i_val).val();
        var exy_val = $('#excutive_y'+i_val).val();
        
        var hState = 0;
        var yState = 0;
        
        if(jh_val != "" && mh_val != "" && manh_val !="" && exh_val !=""){
            hState = 1;

            validateJunior_hD();
            validatemidlevel_hD();
            validatemanager_hD();
            validateexcutive_hD();

            $('#junior_ycheck'+i_val).hide();
            $('#midlevel_ycheck'+i_val).hide();
            $('#manager_ycheck'+i_val).hide();
            $('#excutive_ycheck'+i_val).hide();
         
        }  
        
        if(jy_val != "" && my_val != "" && many_val !="" && exy_val !=""){
            yState = 1;

            validateJunior_yD();
            validatemidlevel_yD();
            validatemanager_yD();
            validateexcutive_yD();

            $('#junior_hcheck'+i_val).hide();
            $('#midlevel_hcheck'+i_val).hide();
            $('#manager_hcheck'+i_val).hide();
            $('#excutive_hcheck'+i_val).hide();
        
        }
        
        // console.log("hState-->"+hState);
        // console.log("yState-->"+yState);
        
        
        
        if(hState == "0" && yState == "0"){
        
         var validateJunior_hDV = validateJunior_hD();
            var validatemidlevel_hDV = validatemidlevel_hD();
            var validatemanager_hDV = validatemanager_hD();
            var validateexcutive_hDV = validateexcutive_hD();
            
            
            var validateJunior_yDV = validateJunior_yD();
            var validatemidlevel_yDV = validatemidlevel_yD();
            var validatemanager_yDV = validatemanager_yD();
            var validateexcutive_yDV = validateexcutive_yD();
            
        }else{ 
            var validateJunior_hDV = true;
            var validatemidlevel_hDV = true;
            var validatemanager_hDV = true;
            var validateexcutive_hDV = true;
            
            
            var validateJunior_yDV = true;
            var validatemidlevel_yDV = true;
            var validatemanager_yDV = true;
            var validateexcutive_yDV = true;
        }
        if(fromCall == "add"){
            //////////
            
            if(!validateStateV || !validateCountyV || !validateCityV || !validateTitleDV || !validateCodeDV ||  !validateJunior_hDV || !validateJunior_yDV  || (!validatemidlevel_hDV || !validatemidlevel_yDV) || !validatemanager_hDV || !validatemanager_yDV|| !validateexcutive_hDV || !validateexcutive_yDV) {
               // alert("Please fill all the required fields For wage "+i+" ");  
             
                  return true;
               }else{
                 //i++;
                
              var cur_val = $("#iterIncr").val();
              console.log('cur_val  '+cur_val);
              cur_val = parseInt(cur_val);
              var next_val = cur_val + 1;
              console.log('cur_val  '+cur_val);
              $("#iterIncr").val(next_val);
                 dynamic_field(next_val); 
               }
              
            ///////////
        }
        
        
        if(fromCall == "submit"){
            ////
            if(!validateStateV || !validateCountyV || !validateCityV || !validateTitleDV || !validateCodeDV ||  !validateJunior_hDV || !validateJunior_yDV  || (!validatemidlevel_hDV || !validatemidlevel_yDV) || !validatemanager_hDV || !validatemanager_yDV|| !validateexcutive_hDV || !validateexcutive_yDV) {
              //alert("Please fill all the required fields");
           
          
              
              return false;
            }else{
             //alert("success")
         // document.getElementByID("wagesurveyForm")
             return true;
    
          //$("#wagesurveyForm").submit();
            }
            
            
            ////
        }
        
    //
    
    }


      function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(reader.result);

          var base64result = reader.result.split(',')[1];
          //setBannerBase64(reader.result)
          setBannerBase64(base64result);
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
     }

      function getImage(){
        var files = document.getElementById('banner').files;     
        
        if (files.length > 0) {
            var fname = files[0].name;
            var fextn = fname.split(".").pop();
            var fileActName = fname.split(".")[0];
            setImageName(fileActName);
            setImageExtension(fextn);           
          getBase64(files[0]);
        }
      }  
    useEffect(() => {
        const jsonData = {
            "wageSurvey": {
              
            }
          };
          var jsondataformatted = JSON.stringify(jsonData);
          sessionStorage.setItem('pagejsonObject', jsondataformatted);

        $("#matchPwd").hide();
        $('#phone').usPhoneFormat();
        $( "#passwordTxtConf" ).blur(function() {
            var passwordConf = $("#passwordTxtConf").val();
            var passwordCheck = $("#passwordTxt").val();
            if(passwordConf != passwordCheck){
            $("#matchPwd").show();          
            }else{
            $("#matchPwd").hide();
            }
        });
       
          if(companyIdChkLogin == null || companyIdChkLogin == "null"){            
            //navigate('/login');
            navigate('/Home');
          }
        //getUserProfile();
        getStatesWage();
        getLocationCounty();
        $("#successMessage").hide();
        $("#imgError").hide();

        var i=1;
        $("#iterIncr").val(i);
        dynamic_field(i);
        $('#statecheck').hide();
        $('#countycheck').hide();
        $('#citycheck').hide();
 
    }, []);
    
    function dynamic_field(i){
        if(i > 1)
              {
                $('#dynamic_field').append('<div id="row'+i+'"><h4>Wage for job -'+i+'</h4><button type="button" name="remove" id="'+i+'" class="btn btn-danger btn_remove" style="cursor: pointer;">Remove</button><div class="col-lg-12 mb-4"> <label class="form-label required">Job Title<span class="red-text">*</span></label> <input type="text" name="job_title[]" onload="jobTitle(this)"  class="form-control jobtitle'+i+'"  id="job_title'+i+'" autocomplete="off"  ><p id="jobtitlecheck'+i+'"></p></div><div class="col-lg-12 mb-4"> <label class="form-label required">Standardized job code<span class="red-text">*</span></label> <span class="fielddesc">Type keywords to pick standardized job code from the list. Please pick a code that matches closely to your job."</span> <input type="text" name="job_code[]" onblur="checkJobcode(this.value,'+i+')" id="job_code'+i+'"  class="form-control jobCode'+i+' ui-autocomplete-input" it_val='+i+' autocomplete="off" on><p id="jobcodecheck'+i+'"></p><span id="jobcodeError'+i+'"></span></div><div class="clear formrow"><div class="col-lg-12 my-4" > <label class="form-label border-bottom w-100">SOC Code:  <span id="socCodeTxt'+i+'" style="font-weight: normal;"></span></label><input type="hidden" name="soccode[]" class="form-control" readonly="" id="soccode'+i+'" value="51-5111.01"></div><div class="col2" style="display:none;"> <label>SOC Code</label><input type="text" name="occcode" class="form-control" readonly="" id="occcode'+i+'" value="51-5111.01"></div></div><div class="formsection level-wrap"><h4>Wage</h4><div class="wage"><div class="wage-item"><div class="d-grid"><b>Level 1<span class="red-text">*</span></b><small>Junior</small></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">Hourly</label><input type="text" name="junior_h[]"  id="junior_h'+i+'" onkeyup="validateDecimalThree(this)" maxlength="6"><p id="junior_hcheck'+i+'"></p></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">yearly</label> <input type="text" name="junior_y[]" id="junior_y'+i+'" onkeyup="validateDecimal(this)" maxlength="7" ><p id="junior_ycheck'+i+'"></p></div></div></div><div class="wage"><div class="wage-item"><div class="d-grid"><b>Level 2<span class="red-text">*</span></b> <small>Mid Level</small></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">Hourly</label><input type="text" name="midlevel_h[]"  id="midlevel_h'+i+'" onkeyup="validateDecimalThree(this)" maxlength="6"><p id="midlevel_hcheck'+i+'"></p></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">yearly</label><input type="text" name="midlevel_y[]" id="midlevel_y'+i+'"  onkeyup="validateDecimal(this)" maxlength="7" ><p id="midlevel_ycheck'+i+'"></p></div></div></div><div class="wage"><div class="wage-item"><div class="d-grid"><b>Level 3<span class="red-text">*</span></b> <small>Managerial</small></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">Hourly</label><input type="text" name="manager_h[]"   id="manager_h'+i+'" onkeyup="validateDecimalThree(this)" maxlength="6"><p id="manager_hcheck'+i+'"></p></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">Yearly</label><input type="text" name="manager_y[]"  id="manager_y'+i+'"  onkeyup="validateDecimal(this)" maxlength="7" ><p id="manager_ycheck'+i+'"></p></div></div></div><div class="wage"><div class="wage-item"><div class="d-grid"><b>Level 4<span class="red-text">*</span></b> <small>Executive</small></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">Hourly</label><input type="text" name="excutive_h[]"  id="excutive_h'+i+'"  onkeyup="validateDecimalThree(this)" maxlength="6"><p id="excutive_hcheck'+i+'"></p></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">Yearly</label><input type="text" name="excutive_y[]" id="excutive_y'+i+'" onkeyup="validateDecimal(this)" maxlength="7" ><p id="excutive_ycheck'+i+'"></p></div></div></div><span style="margin-top:50px;"></span></div></div>'); 
           // autoCompleteInit(i);
              }
              else
              {   
              $('#dynamic_field').append('<div id="row'+i+'"><h4 class="wage-ttl">Wage for job -'+i+'</h4><div class="col-lg-12 mb-4 px-3"> <label class="form-label required">Job Title<span class="red-text">*</span></label> <input type="text" name="job_title[]" onload="jobTitle(this)" value="" class="form-control jobtitle'+i+'"  id="job_title'+i+'" autocomplete="off" ><p id="jobtitlecheck'+i+'"></p></div><div class="col-lg-12 mb-4 d-flex flex-column px-3"> <label class="form-label required">Standardized job code <span class="red-text">*</span></label> <span class="fielddesc">Type keywords to pick standardized job code from the list. Please pick a code that matches closely to your job."</span> <input type="text" name="job_code[]" onblur="checkJobcode(this.value,'+i+')"  id="job_code'+i+'"  class="form-control jobCode'+i+' ui-autocomplete-input" it_val='+i+' autocomplete="off" ><p id="jobcodecheck'+i+'"></p><span id="jobcodeError'+i+'"></span></div><div class="clear formrow"><div class="col-lg-12 px-3" > <label class="form-label border-bottom w-100">SOC Code:  <span id="socCodeTxt'+i+'" style="font-weight: normal;"></span></label><input type="hidden" name="soccode[]" class="form-control" readonly="" id="soccode'+i+'" value="51-5111.01"></div><div class="col2" style="display:none;"> <label>SOC Code</label><input type="text" name="occcode" class="form-control" readonly="" id="occcode'+i+'" value="51-5111.01"></div></div><div class="formsection level-wrap px-3"><h4>wage</h4><div class="wage"><div class="wage-item"><div class="d-grid"><b>Level 1 <span class="red-text">*</span></b><small>Junior</small></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">Hourly</label><input type="text" name="junior_h[]"  id="junior_h'+i+'" onkeyup="validateDecimalThree(this)" maxlength="6"><p id="junior_hcheck'+i+'"></p></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">yearly</label><input type="text" name="junior_y[]" id="junior_y'+i+'"  onkeyup="validateDecimal(this)" maxlength="7" ><p id="junior_ycheck'+i+'"></p></div></div></div><div class="wage"><div class="wage-item"><div class="d-grid"><b>Level 2 <span class="red-text">*</span></b><small>Mid Level</small></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">Hourly</label> <input type="text" name="midlevel_h["  id="midlevel_h'+i+'" onkeyup="validateDecimalThree(this)" maxlength="6"><p id="midlevel_hcheck'+i+'"></p></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">yearly</label><input type="text" name="midlevel_y[]" id="midlevel_y'+i+'"  onkeyup="validateDecimal(this)" maxlength="7" ><p id="midlevel_ycheck'+i+'"></p></div></div></div><div class="wage"><div class="wage-item"><div class="d-grid"><b>Level 3 <span class="red-text">*</span></b><small>Managerial</small></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">Hourly</label><input type="text" name="manager_h["  id="manager_h'+i+'" onkeyup="validateDecimalThree(this)" maxlength="6"><p id="manager_hcheck'+i+'"></p></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">yearly</label><input type="text" name="manager_y[]" id="manager_y'+i+'"  onkeyup="validateDecimal(this)" maxlength="7" ><p id="manager_ycheck'+i+'"></p></div></div></div><div class="wage"><div class="wage-item"><div class="d-grid"><b>Level 4 <span class="red-text">*</span></b><small>Executive</small></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">Hourly</label><input type="text" name="excutive_h["  id="excutive_h'+i+'" onkeyup="validateDecimalThree(this)" maxlength="6"><p id="excutive_hcheck'+i+'"></p></div></div><div class="wage-item"><div class="d-grid"><label htmlFor="">yearly</label><input type="text" name="excutive_y[]" id="excutive_y'+i+'"  onkeyup="validateDecimal(this)" maxlength="7" ><p id="excutive_ycheck'+i+'"></p></div></div></div><span style="margin-top:50px;"></span></div></div>');
              //autoCompleteInit(i);
              }
       }
       function validateState() {
            var dValue = $('#state').val();
            if(dValue != ""){
                $('#statecheck').hide();
                return true;
            }else{
                $('#statecheck').css("color", "red").html("*State field is required");
                $('#statecheck').show();
                return false;
            }
     
        }
        function validateCounty() {
            var dValue = $('#getCounty').val();
            if(dValue != ""){
                $('#countycheck').hide();
                return true;
            }else{
                $('#countycheck').css("color", "red").html("*County field is required");
                $('#countycheck').show();
                return false;
            }
     
        }
     
        function validateCity() {
            var dValue = $('#city').val();
            if(dValue != ""){
                $('#citycheck').hide();
                return true;
            }else{
                $('#citycheck').css("color", "red").html("*City field is required");
                $('#citycheck').show();
                return false;
            }
     
        }
        function validateTitleD() {
            var i_val = $("#iterIncr").val();
               var dValue = $('#job_title'+i_val).val();
                 if(dValue != ""){
                 
                  $('#jobtitlecheck'+i_val).hide();
                  return true;
                 }else{
                  $('#jobtitlecheck'+i_val).css("color", "red").html("*Title field is required");
                  $('#jobtitlecheck'+i_val).show();
                  return false;
                 }
            
               }
    
               function validateCodeD() {
                    var i_val = $("#iterIncr").val();
                       var dValue = $('#job_code'+i_val).val();
                       if(dValue != ""){
                       
                       $('#jobcodecheck'+i_val).hide();
                       return true;
                       }else{
                       $('#jobcodecheck'+i_val).css("color", "red").html("*Jobcode field is required");
                       $('#jobcodecheck'+i_val).show();
                       return false;
                       }
    
                       }
                       function validateJunior_hD() {
                        var i_val = $("#iterIncr").val();
                           var dValue = $('#junior_h'+i_val).val();
                           if(dValue != ""){
                             $('#junior_hcheck'+i_val).hide();
                           return true;
                           }else{
                             $('#junior_hcheck'+i_val).css("color", "red").html("*Level 1 hourly field is required");
                            $('#junior_hcheck'+i_val).show();
                           return false;
                           }
                       }        
    
                        function validateJunior_yD() {
                         var i_val = $("#iterIncr").val();
                           var dValue = $('#junior_y'+i_val).val();
                           if(dValue != ""){
                             $('#junior_ycheck'+i_val).hide();
                           return true;
                           }else{
                             $('#junior_ycheck'+i_val).css("color", "red").html("*Level 1 yearly field is required");
                            $('#junior_ycheck'+i_val).show();
                           return false;
                           }
                       } 

                       function validatemidlevel_hD() {
   				 	var i_val = $("#iterIncr").val();
                          var dValue = $('#midlevel_h'+i_val).val();
                          if(dValue != ""){
                            $('#midlevel_hcheck'+i_val).hide();
                          return true;
                          }else{
                            $('#midlevel_hcheck'+i_val).css("color", "red").html("*Level 2 hourly field is required");
                           $('#midlevel_hcheck'+i_val).show();
                          return false;
                          }
                      }        
   
                       function validatemidlevel_yD() {
   				 	var i_val = $("#iterIncr").val();
                          var dValue = $('#midlevel_y'+i_val).val();
                          if(dValue != ""){
                            $('#midlevel_ycheck'+i_val).hide();
                          return true;
                          }else{
                            $('#midlevel_ycheck'+i_val).css("color", "red").html("*Level 2 yearly field is required");
                           $('#midlevel_ycheck'+i_val).show();
                          return false;
                          }
                      }    
   
                       function validatemanager_hD() {
   				 	var i_val = $("#iterIncr").val();
                          var dValue = $('#manager_h'+i_val).val();
                          if(dValue != ""){
                            $('#manager_hcheck'+i_val).hide();
                          return true;
                          }else{
                            $('#manager_hcheck'+i_val).css("color", "red").html("*Level 3 hourly field is required");
                           $('#manager_hcheck'+i_val).show();
                          return false;
                          }
                      }        
   
                       function validatemanager_yD() {
   				 	var i_val = $("#iterIncr").val();
                          var dValue = $('#manager_y'+i_val).val();
                          if(dValue != ""){
                            $('#manager_ycheck'+i_val).hide();
                          return true;
                          }else{
                            $('#manager_ycheck'+i_val).css("color", "red").html("*Level 3 yearly field is required");
                           $('#manager_ycheck'+i_val).show();
                          return false;
                          }
                      }    
   
                       function validateexcutive_hD() {
   				 	var i_val = $("#iterIncr").val();
                          var dValue = $('#excutive_h'+i_val).val();
                          if(dValue != ""){
                            $('#excutive_hcheck'+i_val).hide();
                          return true;
                          }else{
                            $('#excutive_hcheck'+i_val).css("color", "red").html("*Level 4 hourly field is required");
                           $('#excutive_hcheck'+i_val).show();
                          return false;
                          }
                      }        
   
                       function validateexcutive_yD() {
   				 	var i_val = $("#iterIncr").val();
                          var dValue = $('#excutive_y'+i_val).val();
                          if(dValue != ""){
                          $('#excutive_ycheck'+i_val).hide();
                          return true;
                          }else{
                            $('#excutive_ycheck'+i_val).css("color", "red").html("*Level 4 yearly field is required");
                           $('#excutive_ycheck'+i_val).show();
                          return false;
                          }
                      }        
    
                       const getLocationCounty = () => {
        services.getLocationCounty().then((res) => {
 console.log(res);
            setCountyList(res.data);
        
        });
     }

    const getStatesWage = () => {
        services.getStatesFromWage().then((res) => {
 
            setStateList(res.data);
        
        });
     }

    const getUserProfile = () => {
        services.getUserInfo(userId).then((res) => {
 
         setProfileDetails(res.data);
         $("#firstNameTxt").val(res.data.firstName);
         $("#lastNameTxt").val(res.data.lastName);
         $("#emailTxt").val(res.data.email);
         $("#phone").val(res.data.phone);
         //emaildefault = res.data.email;
         setemaildefault(res.data.email)
         setProfilePicS3URL(res.data.profilePicS3URL)
         // alert(profileDetails.name);
        });
     }

      const submitValue=()=>
      {
          var numjobs_added = $('#iterIncr').val();
          var wages = [];
          for(var i=0; i< numjobs_added; i++){
            var wage_item = '';
            var wagei = parseInt(i+1)
            wage_item = 
            {
                "wage_id" : wagei,
                "job_title" :  $('#job_title'+wagei).val(),
                "job_code" : $('#job_code'+wagei).val(),
                "soc_code" : $('#soccode'+wagei).val(),
                "junior_hourly" : $('#junior_h'+wagei).val(),
                "junior_yearly" : $('#junior_y'+wagei).val(),
                "mid_hourly" : $('#midlevel_h'+wagei).val(),
                "mid_yearly" : $('#midlevel_y'+wagei).val(),
                "managerial_hourly" : $('#manager_h'+wagei).val(),
                "managerial_yearly" : $('#manager_y'+wagei).val(),
                "executive_hourly" : $('#excutive_h'+wagei).val(),
                "executive_yearly" : $('#excutive_y'+wagei).val(),
            };
            wages.push(wage_item);
          }  
       const requestObject =
       {
           "siteId": process.env.React_App_SITE_ID,
            "state" : $('#state').val(),
            "city" : $('#city').val(),
            "county" : $('#getCounty').val(),
            "wage_surveyinfo" : wages
       }
       
       console.log(requestObject); return false;
     
      }
      function validateDecimalThree(elem) {
        var ex=  /^\d{0,3}(\.\d{0,2})?$/;
      if(ex.test(elem.value)==false){
      elem.value = elem.value.substring(0,elem.value.length - 1);
      }
      }
      
      function validateDecimal(elem) {
      
              var ex = /^[0-9]+\.?[0-3]*$/;
      if(ex.test(elem.value)==false){
      elem.value = elem.value.substring(0,elem.value.length - 1);
      }
      
      // if((elem.value.length < 3)|| 
      //       (dValue.length > 7)) {
      //         $('#junior_ycheck').css("color", "red").html("*Junior Yearly should be more than 3 Digits");
      //                  $('#junior_ycheck').show();
      //                 return false;
      //          }else{
      //           $('#junior_ycheck').hide();
      //            return true;
      //          }
      
      }
  return(
  <>
<main class="empr-directory-main">
        <div class="main-bgpatten"></div>
        {/* <!-- info typography --> */}
        
        <section class="headtitle-wrap">
        
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <nav style={{"--bs-breadcrumb-divider": "'>';"}} aria-label="breadcrumb">
                            <ol class="breadcrumb">

                            {(() => {
                                
                                if( companyIdChkLogin != null && companyIdChkLogin != "null"){            
                                    return (<> <li class="breadcrumb-item headtitle "><a href="/companyJobs">Company Dashboard</a> </li>
                                    <li class="breadcrumb-item headtitle "><a href="#">Wage Survey</a></li></>);
                                }
                                })()}    

                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- info typography --> */}
        <section class="py-5">
            <div class="container">
                <div class="row">
                    <div class="col-12 ">
                        <div class="white-bg p-5">
                            <div class="row">
                                {/* <!-- left side --> */}

                                {(() => {
                                
                                if( companyIdChkLogin != null && companyIdChkLogin != "null"){            
                                    return (<><Quick_links/></>);
                                }
                                })()}    
                                {/* <!-- right side --> */}
                                <div class="col-lg-8 mb-4">
                                <form id="wagesurveyForm" name="wagesurveyForm" onSubmit={handleSubmit(submitValue)} >
                                   <input type="hidden" id="iterIncr" name="iterIncr"  />
                                    <div class="row resume-wrap">
                                        <div class="col-lg-12 mb-4">
                                            <label for="firstName" class="form-label">State<span class="red-text">*</span></label>
                                           

                                            <select class="form-select" id="state">
                                        <option selected>List of States</option>
                                        {
                                        stateList.map((data, index) => (
                                        <option value={data.stateId}>{data.stateName}</option>
                                        ))}
                                      </select>
                                      <p id="statecheck">State is Required</p>

                                        </div>
                                        <div class="col-lg-6">
                                            <label for="firstName" class="form-label">City<span class="red-text">*</span></label>
                                            <input type="text"  class="form-control" id="city"  defaultValue=""  {...register('cityval', { required: true })}/>
                                            <p id="citycheck">City is Required</p>
                                        </div>
                                        <div class="col-lg-6">
                                            <label for="firstName" class="form-label">County<span class="red-text">*</span></label>
                                            <select class="form-select" id="getCounty">
                                        <option selected>List of Counties</option>
                                        {
                                        countyList.map((data, index) => (
                                        <option value={data.jobLocationCountyId}>{data.name}</option>
                                        ))}
                                      </select>
                                      <p id="countycheck">Country is Required</p>
                                        </div>
                                        <table class="table" id="dynamic_field" width="100%">  </table>
                                        {/*
                                        <div id="dyna">
                                        <div id="repeat">
                                        <div class="col-lg-12 mb-4">
                                            <label for="firstName" class="form-label">Job Title<span class="red-text">*</span></label>
                                            <input type="text"  class="form-control" id="job_title"  defaultValue=""  {...register('jobbtitle', { required: true })}/>
                                            {errors.email && errors.email.type === "required" && <div class="error">Job Title is required</div>}
                                        </div>
                                        <div class="col-lg-12 mb-4">
                                            <label for="firstName" class="form-label">Standardized job code<span class="red-text">*</span></label>
                                            <input type="text"  class="form-control" id="job_code"  defaultValue=""  {...register('jobcode', { required: true })}/>
                                            {errors.email && errors.email.type === "required" && <div class="error">Email is required</div>}
                                        </div> 

                                        <div class="col-lg-12 my-4">
                                       <label for="phone" class="form-label border-bottom w-100">Soc Code</label>
                                        <h4>wage</h4> 
                                       <div class="wage-wrp">
                                
                                       <div className="wage">
                                            <div className="wage-item">
                                                <div className="d-grid">
                                                    <b>Level 1 <span className="red-text">*</span></b>
                                                    <small>Junior</small>
                                                </div>
                                                
                                            </div>
                                            <div className="wage-item">
                                            <div className="d-grid">
                                                    <label htmlFor="">Hourly</label>
                                                    <input type="text" />
                                                </div>
                                            </div>

                                            <div className="wage-item">
                                            <div className="d-grid">
                                                    <label htmlFor="">yearly</label>
                                                    <input type="text" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="wage">
                                            <div className="wage-item">
                                                <div className="d-grid">
                                                    <b>Level 2 <span className="red-text">*</span></b>
                                                    <small>Mid Level</small>
                                                </div>
                                                
                                            </div>
                                            <div className="wage-item">
                                            <div className="d-grid">
                                                    <label htmlFor="">Hourly</label>
                                                    <input type="text" />
                                                </div>
                                            </div>

                                            <div className="wage-item">
                                            <div className="d-grid">
                                                    <label htmlFor="">yearly</label>
                                                    <input type="text" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="wage">
                                            <div className="wage-item">
                                                <div className="d-grid">
                                                    <b>Level 3 <span className="red-text">*</span></b>
                                                    <small>Managerial</small>
                                                </div>
                                                
                                            </div>
                                            <div className="wage-item">
                                            <div className="d-grid">
                                                    <label htmlFor="">Hourly</label>
                                                    <input type="text" />
                                                </div>
                                            </div>

                                            <div className="wage-item">
                                            <div className="d-grid">
                                                    <label htmlFor="">yearly</label>
                                                    <input type="text" />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="wage">
                                            <div className="wage-item">
                                                <div className="d-grid">
                                                    <b>Level 4<span className="red-text">*</span></b>
                                                    <small>Executive</small>
                                                </div>
                                                
                                            </div>
                                            <div className="wage-item">
                                            <div className="d-grid">
                                                    <label htmlFor="">Hourly</label>
                                                    <input type="text" />
                                                </div>
                                            </div>

                                            <div className="wage-item">
                                            <div className="d-grid">
                                                    <label htmlFor="">yearly</label>
                                                    <input type="text" />
                                                </div>
                                            </div>
                                        </div>
                                       </div>
                                      
                                      
                                        </div>

                                        </div>
                                        </div> */}
                                        <div className="d-flex justify-content-between border-top pt-3 px-3">
                                           
                                           <button class="reg-button" id="add_another">add Another job</button>
                                           <button class="reg-button">submit</button>
                                     
                                   </div>
                                       <span id="socCode"></span>

                                        {/*<div id="successMessage" class="alert">
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div class="d-flex align-items-center">
                                                    <img src="/images/success-alert.png" alt=""/>
                                                    <strong class="mx-2">Success!</strong> Details updated successfully.
                                                </div>
                                                <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                                            </div>
                                        </div>*/}


                                        
                                    </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </section>
        {/* <Hiring/> */}
    </main>
  </>
)};

WageSurvey.propTypes = {};

WageSurvey.defaultProps = {};

export default WageSurvey;
